const CM_TO_INCHES = (cm) => (parseFloat(cm) / 2.54).toFixed(4);

export default async function renderTagPreview({ zplCode, widthCm, heightCm, dpmm }) {
  try {
    const widthIn = CM_TO_INCHES(widthCm);
    const heightIn = CM_TO_INCHES(heightCm);

    const formData = new FormData();
    formData.append('file', new Blob([zplCode.trim()], { type: 'application/octet-stream' }));

    const response = await fetch(
      `https://api.labelary.com/v1/printers/${dpmm}/labels/${widthIn}x${heightIn}/0/`,
      { method: 'POST', body: formData }
    );

    if (!response.ok) {
      throw new Error(`Erro ao renderizar: ${response.status} ${response.statusText}`);
    }

    return await response.blob();
  } catch (error) {
    console.log('Error renderTagPreview', error);
    throw error;
  }
}
